import { UseQueryResult } from '@tanstack/react-query';
import { endPointUrls } from 'core/constants/endPointUrls';
import api from 'core/services/fetch-api/useApi';
import useQueryUrlParam from 'core/hooks/useQueryUrlParam';
import useQueryHook from 'core/hooks/masterQuery/useQueryHook';
import { ITransactionList } from 'core/types/models/transactionType';

export const useAdminUserTransactionQuery = () => {
	const { filterParams } = useQueryUrlParam();

	return useQueryHook(
		[endPointUrls.ADMIN_WALLETS_USERS_TRANSACTIONS(), filterParams],
		(data: any) =>
			api.get(endPointUrls.ADMIN_WALLETS_USERS_TRANSACTIONS(filterParams), data),
		{
			select: (res: any) => res?.data,
			keepPreviousData: true,
		}
	) as UseQueryResult<ITransactionList, Error>;
};
